<script lang="ts">
  import { getCommonTranslations } from '@athena-lib/commonTranslationsContext';
  import { Dropdown } from '@athena-lib/Fields';
  import { Column, Columns } from '@athena-lib/Columns';
  import { STATES } from './utils';
  import type { EditAccountData } from '$lib/server/external/types';

  const translations = getCommonTranslations();

  let {
    country_code = $bindable(''),
    county = $bindable(''),
    countries,
  }: {
    country_code: string | null;
    county: string | null;
    countries: EditAccountData['countries'];
  } = $props();

  const countryOptions = $derived.by(() =>
    Object.keys(countries).map((key) => ({ label: countries[key], value: key })),
  );

  const states = $derived.by(() => {
    if (!country_code) {
      return undefined;
    }

    const states = STATES[country_code];

    if (!states) {
      return undefined;
    }

    return Object.keys(states).map((key) => ({ label: states[key], value: key }));
  });

  $effect(() => {
    if (!states) {
      county = '';
    }
  });
</script>

<Columns>
  <Column>
    <Dropdown
      bind:value={country_code}
      options={countryOptions}
      label={translations.country}
      class="bg-white"
    />
  </Column>
  {#if states}
    <Column>
      <Dropdown bind:value={county} options={states} label={translations.state} class="bg-white" />
    </Column>
  {/if}
</Columns>
